<template>
    <div>
        <b-navbar class="header">
            <b-navbar-brand href="/">
                <img alt="Res Image" src="./assets/res.png" class="headerImage" />
            </b-navbar-brand>
            <h1 class="headerText">HTG Admin</h1>
            <button class="logoutButton" @click="logout">{{ this.instance }}</button>
        </b-navbar>
        <div class="loginContainer" v-if="!token">
            <div v-if="!loading">
                <div class="inputContainer">
                    <b-form-select class="inputForms" v-model="instance" :options="this.options"></b-form-select>
                    <b-form-input class="inputForms" v-model="username" placeholder="username"></b-form-input>
                    <b-form-input class="inputForms" @keyup.enter="onSubmit" type="password" v-model="password" placeholder="password"></b-form-input>
                    <b-button class="button" @click="onSubmit">Submit</b-button>
                </div>
            </div>
            <div v-else-if="loading">
                Loading...
            </div>
        </div>
        <div v-else>
            <p>
                <router-link to="/">Home</router-link> / <router-link to="/setupProject">SetupProject</router-link> / <router-link to="/viewScale">viewScale</router-link> /
                <router-link to="/viewRules">viewRules</router-link> / <router-link to="/viewEmployee">viewEmployee</router-link> /
                <router-link to="/viewUnionLocations">viewUnionLocations</router-link>
            </p>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import HTGAuth from './resources/auth'
import BaseResource from './resources/index'
import toastMixin from './mixins/toast'
import { LicenseManager } from 'ag-grid-enterprise'
LicenseManager.setLicenseKey(
    'CompanyName=Revolution Payroll,LicensedGroup=ProBooks,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-011578,ExpiryDate=4_December_2021_[v2]_MTYzODU3NjAwMDAwMA==5da9d3c2699f550dc7daf171582ca3ed'
)

export default Vue.extend({
    data() {
        return {
            username: undefined,
            password: undefined,
            instance: undefined,
            token: undefined,
            loading: false,
            authUrl: '/oasis/restv3/employerAuth',
            authRenewUrl: '/oasis/restv3/employerRenew',
            options: [
                { value: 'https://www.revolutiones.com', text: 'https://www.revolutiones.com' },
                { value: 'https://htgstaging.dev.revolutiones.org', text: 'https://htgstaging.dev.revolutiones.org' },
                { value: 'https://htgdemo.revolutiones.com', text: 'https://htgdemo.revolutiones.com' },
                { value: 'https://localhost', text: 'https://localhost' },
                { value: 'https://dvc.localhost', text: 'https://dvc.localhost' },
                { value: 'https://dvc.localhost:8081', text: 'https://dvc.localhost:8081' },
            ],
        }
    },
    mixins: [toastMixin],
    methods: {
        async onSubmit() {
            let instanceUrl = this.instance
            try {
                const res = await axios.post(`${this.instance}${this.authUrl}`, {
                    username: this.username,
                    password: this.password,
                })
                this.token = res.data.token
                let instanceObj = {
                    instanceUrl: instanceUrl,
                    token: res.data.token,
                }
                this.updateInstances(instanceObj)
            } catch (apiErr) {
                this.createToast('b-toaster-top-center', 'danger', true, 'Login Error', 'Can not login with given credentials')
            }
            this.checkToken()
        },

        updateInstances(instance) {
            let instances = JSON.parse(localStorage.getItem('sigmacloud.approvals.instances')) || []
            //find existing to update
            if (instances.length) {
                let existingInstance = instances.find((inObj) => {
                    return inObj.instanceUrl === instance.instanceUrl
                })
                if (existingInstance && typeof existingInstance === 'object') {
                    let index = instances.indexOf(existingInstance)
                    instances[index].token = instance.token
                } else {
                    instances.push(instance)
                }
            } else {
                instances.push(instance)
            }
            let stringifiedInstances = JSON.stringify(instances)
            localStorage.setItem('sigmacloud.approvals.instances', stringifiedInstances)
            localStorage.setItem('sigmacloud.approvals.recentInstance', instance.instanceUrl)
            this.resources.BaseResource.client = new HTGAuth(this.instance, this.token)
        },

        getTokenForInstance(instanceUrl) {
            let instances = JSON.parse(localStorage.getItem('sigmacloud.approvals.instances')) || []
            if (instances.length) {
                let instance = instances.find((inObj) => {
                    return inObj.instanceUrl === instanceUrl
                })
                if (instance && typeof instance === 'object') {
                    return instance.token
                }
            }
            return undefined
        },

        deleteTokenForInstance(instanceUrl) {
            let instances = JSON.parse(localStorage.getItem('sigmacloud.approvals.instances')) || []
            if (instances.length) {
                let instanceObj = instances.find((inObj) => {
                    return inObj.instanceUrl === instanceUrl
                })
                let index = instances.indexOf(instanceObj)
                instances[index].token = ''
                let stringifiedInstances = JSON.stringify(instances)
                localStorage.setItem('sigmacloud.approvals.instances', stringifiedInstances)
            }
        },

        async renewAuth() {
            try {
                const res = await axios.post(
                    `${this.instance}${this.authRenewUrl}`,
                    {},
                    {
                        headers: {
                            Authorization: this.resources.BaseResource.client.config.headers.Authorization,
                        },
                    }
                )

                this.token = res.data.token
                let instanceObj = {
                    instanceUrl: this.instance,
                    token: res.data.token,
                }
                this.updateInstances(instanceObj)
            } catch (apiErr) {
                // console.log('error : ' + apiErr)
            }
        },

        checkToken() {
            // token was updated by another tab
            const renewToken = this.getTokenForInstance(this.instance)
            if (renewToken && this.token != renewToken) {
                // update current tab
                this.token = renewToken
                this.resources.BaseResource.client = new HTGAuth(this.instance, this.token)
            }
            const payload = this.resources.BaseResource.client.getTokenPayload()
            // expire time - now < 5 mins -> renew
            if (payload && Date.now() < payload.expires * 1000 && Date.now() > payload.expires * 1000 - 300 * 1000) {
                this.renewAuth()
            }
            // set timer every 5 mins
            setTimeout(this.checkToken, 300 * 1000)
        },

        logout() {
            this.deleteTokenForInstance(this.instance)
            this.token = undefined
        },
    },

    computed: {
        resources() {
            return {
                BaseResource,
            }
        },
    },

    created() {
        this.instance = 'https://www.revolutiones.com'
        let recentInstance = localStorage.getItem('sigmacloud.approvals.recentInstance')

        if (recentInstance && recentInstance.length) {
            this.instance = recentInstance
            let token = this.getTokenForInstance(recentInstance)

            if (token && token.length) {
                this.resources.BaseResource.client = new HTGAuth(this.instance, token)
                const payload = this.resources.BaseResource.client.getTokenPayload()
                if (payload && Date.now() < payload.expires * 1000) {
                    this.token = token
                } else {
                    // expired token
                    this.resources.BaseResource.client = undefined
                }
            }
        }
        if (this.token) this.checkToken()
    },
})
</script>

<style>
.header {
    display: flex;
    background-color: #000000;
}

.headerImage {
    margin: 20px 0 20px 0;
}

.headerText {
    align-self: center;
    margin: 0;
    position: absolute;
    left: 47%;
    color: #ffffff;
}

.loginContainer {
    height: 100%;
    margin: 50px 0px 0px 25px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.logoutButton {
    background-color: black;
    outline: none;
    align-self: right;
    position: absolute;
    left: 75%;
    border: none;
    font-size: 25px;
    color: #ffffff;
}

.inputContainer {
    width: 100%;
}

.inputForms {
    margin-bottom: 5%;
}
</style>
